<template>
    <div class="user-list-box" id="user-list-box">
        <title-nav :title="'用户列表'"/>
        <div>
          {{ msg }}
        </div>
        <div class="superior">
          <my-table :columns="columnsA" :data="tableListA" />
        </div>
        <div class="subordinate">
          <my-table :columns="columnsB" :data="tableListB" />
        </div>
    </div>
</template>

<script>
import TitleNav from '../../components/nav/TitleNav.vue'
import myTable from '../../components/table/index.vue'

export default {
  name: 'UserList',
  components: {
    TitleNav,
    myTable
  },
  created(){
  },
  mounted(){
  },
  data:()=>{
    return {
      msg: '',
      columnsA: [
        { title: '归属', field: 'equity', color: '#f0f9eb' },
        { title: '昵称', field: 'nickname', color: '#f0f9eb' },
        { title: '生效日期', field: 'datetime', color: '#f0f9eb' },
      ],
      tableListA: [
        { equity: '上级用户', nickname: '张三', datetime: '2023-06-08 21:45:00' },
      ],
      columnsB: [
        { title: '归属', field: 'equity', color: '#f0f9eb' },
        { title: '昵称', field: 'nickname', color: '#f0f9eb' },
        { title: '生效日期', field: 'datetime', color: '#f0f9eb' },
      ],
      tableListB: [
        { equity: '下级用户', nickname: '李四', datetime: '2023-06-08 21:55:00' },
      ],
    }
  },
  methods:{

  },
  activated(){

  }
}
</script>

<style scoped lang="scss">
.user-list-box {
    min-height: calc(100vh - 20px);
    padding: 0px 0 20px;
    background: #fff;
    .superior {
        margin: 20px 20px;
    }
    .subordinate {
      margin: 20px 20px;
    }
}
</style>